<template>
  <div class="container">
    <CommonHeader
      title="商家券账单"
      :value="`总账单金额：${totalAmount}元`"
    />
    <div
      class="cell-card"
      @click="gotoDetail(COUPON_TYPE.DISCOUNT, discountBillAmount)"
    >
      <div class="cell-head">
        <div class="head-left">
          收费折扣券
        </div>
        <div class="head-right">
          查看详情
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="cell-row">
        <div>
          核销数量：{{ discountWriteOffCount }}张
        </div>
        <div>
          账单金额：{{ discountBillAmount | formatAmount }}元
        </div>
      </div>
    </div>
    <div
      class="cell-card"
      @click="gotoDetail(COUPON_TYPE.FREEDISCOUNT)"
    >
      <div class="cell-head">
        <div class="head-left">
          免费折扣券
        </div>
        <div class="head-right">
          查看详情
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="cell-row">
        <div>
          核销数量：{{ freeDiscountWriteOffCount }}张
        </div>
      </div>
    </div>
    <div
      class="cell-card"
      @click="gotoDetail(COUPON_TYPE.TIME, timeBillAmount)"
    >
      <div class="cell-head">
        <div class="head-left">
          收费时长券
        </div>
        <div class="head-right">
          查看详情
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="cell-row">
        <div>
          核销数量：{{ timeWriteOffCount }}张
        </div>
        <div>
          账单金额：{{ timeBillAmount | formatAmount }}元
        </div>
      </div>
    </div>
    <div
      class="cell-card"
      @click="gotoDetail(COUPON_TYPE.FREE_TIME)"
    >
      <div class="cell-head">
        <div class="head-left">
          免费时长券
        </div>
        <div class="head-right">
          查看详情
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="cell-row">
        <div>
          核销数量：{{ freeTimeWriteOffCount }}张
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CommonHeader from '@/components/CommonHeader';
import { formatAmount } from '@/util/filter';
import Api from '@/api/bill';
import { COUPON_TYPE } from '@/constants/bill';
import STATUS from '@/constants/status';

export default {
  name: 'CouponBill',
  components: { CommonHeader },
  data() {
    return {
      COUPON_TYPE,
      totalAmount: '0.00',
      discountWriteOffCount: 0,
      discountBillAmount: '0.00',
      timeWriteOffCount: 0,
      timeBillAmount: '0.00',
      freeTimeWriteOffCount: 0,
      freeDiscountWriteOffCount: 0,
    };
  },
  computed: {
    ...mapState('billModule', ['currentBilledInfo', 'customerId']),
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const { customerId } = this;
      const { cutMonth: billMonth } = this.currentBilledInfo;
      const params = {
        customerId,
        billMonth,
      };
      const { code, data } = await Api.getCouponBill(params);
      if (code === STATUS.SUCCESS) {
        this.totalAmount = formatAmount(data.totalAmount);
        this.discountWriteOffCount = data.discountWriteOffCount;
        this.discountBillAmount = data.discountBillAmount;
        this.timeWriteOffCount = data.timeWriteOffCount;
        this.timeBillAmount = data.timeBillAmount;
        this.freeTimeWriteOffCount = data.freeTimeWriteOffCount;
        this.freeDiscountWriteOffCount = data.freeDiscountWriteOffCount;
      }
    },
    gotoDetail(couponType, amount = 0) {
      this.$router.push({
        name: 'CouponDetail',
        query: {
          couponType,
          amount: formatAmount(amount),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 16px;
}

.cell-card {
  margin-bottom: 30px;
  .cell-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 30px;

    .head-right {
      font-weight: normal;
      font-size: 26px;
      flex-basis: 180px;
    }
  }

  .cell-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 6px;
    &:last-child {
      padding-bottom: 0;
    }

  }
}

</style>
